import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import { obx, createModuleEventBus } from '@alilc/lowcode-editor-core';
import { isNode } from '@alilc/lowcode-utils';
export var ActiveTracker = (_dec = obx.ref, (_class = /*#__PURE__*/function () {
  function ActiveTracker() {
    _initializerDefineProperty(this, "_target", _descriptor, this);
    this.emitter = createModuleEventBus('ActiveTracker');
  }
  var _proto = ActiveTracker.prototype;
  _proto.track = function track(originalTarget) {
    var target = originalTarget;
    if (isNode(originalTarget)) {
      target = {
        node: originalTarget
      };
    }
    this._target = target;
    this.emitter.emit('change', target);
  };
  _proto.onChange = function onChange(fn) {
    var _this = this;
    this.emitter.addListener('change', fn);
    return function () {
      _this.emitter.removeListener('change', fn);
    };
  };
  _createClass(ActiveTracker, [{
    key: "currentNode",
    get: function get() {
      var _this$_target;
      return (_this$_target = this._target) === null || _this$_target === void 0 ? void 0 : _this$_target.node;
    }
  }, {
    key: "detail",
    get: function get() {
      var _this$_target2;
      return (_this$_target2 = this._target) === null || _this$_target2 === void 0 ? void 0 : _this$_target2.detail;
    }

    /**
     * @deprecated
     */
    /* istanbul ignore next */
  }, {
    key: "intance",
    get: function get() {
      return this.instance;
    }
  }, {
    key: "instance",
    get: function get() {
      var _this$_target3;
      return (_this$_target3 = this._target) === null || _this$_target3 === void 0 ? void 0 : _this$_target3.instance;
    }
  }]);
  return ActiveTracker;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_target", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));